import React from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { Title } from 'components';
import {
  MasonryWrapper,
  MasonryItemOne,
  MasonryItemTwo,
  MasonryItemThree,
  MasonryItemFour,
  MasonryItemFive,
  MasonryItemSix,
  MasonryItemOverlay,
  MasonryInfo,
} from '../Main.styles';

const CollectionMasonryGrid = ({ dataLanding }) => {
  const intl = useIntl();

  React.useEffect(() => {
    console.log('dataLanding: ', dataLanding);
  }, [dataLanding]);

  // propsInCollection
  console.log('dataLand: ', dataLanding);
  console.log(dataLanding);
  return (
    <>
      {dataLanding &&
        dataLanding.landingInfo &&
        dataLanding.landingInfo.collectionList.length && (
          <MasonryWrapper>
            <MasonryItemOne
              bg={`https://aktis.villas/media/${dataLanding.landingInfo.collectionList[0].collectionCover}`}
            >
              <Link
                to={`${dataLanding.landingInfo.collectionList[0].collectionUrl}`}
                style={{ display: 'contents' }}
              >
                <MasonryItemOverlay />
                <MasonryInfo>
                  <Title sizeMbl="18px" size="24px" color="#fff">
                    {dataLanding.landingInfo.collectionList[0].collectionName}
                  </Title>
                  <Title sizeMbl="12px" size="16px" color="#fff">
                    {
                      dataLanding.landingInfo.collectionList[0]
                        .propsInCollection
                    }
                    {intl.formatMessage({
                      id: 'main-page.collections.offers',
                    })}
                  </Title>
                </MasonryInfo>
              </Link>
            </MasonryItemOne>
            {dataLanding.landingInfo.collectionList[1] && (
              <MasonryItemTwo
                bg={`https://aktis.villas/media/${dataLanding.landingInfo.collectionList[1].collectionCover}`}
              >
                <Link
                  to={`${dataLanding.landingInfo.collectionList[1].collectionUrl}`}
                  style={{ display: 'contents' }}
                >
                  <MasonryItemOverlay />

                  <MasonryInfo>
                    <Title sizeMbl="18px" size="24px" color="#fff">
                      {dataLanding.landingInfo.collectionList[1].collectionName}
                    </Title>
                    <Title sizeMbl="12px" size="16px" color="#fff">
                      {
                        dataLanding.landingInfo.collectionList[1]
                          .propsInCollection
                      }
                      {intl.formatMessage({
                        id: 'main-page.collections.offers',
                      })}
                    </Title>
                  </MasonryInfo>
                </Link>
              </MasonryItemTwo>
            )}

            {dataLanding.landingInfo.collectionList[2] && (
              <MasonryItemThree
                bg={`https://aktis.villas/media/${dataLanding.landingInfo.collectionList[2].collectionCover}`}
              >
                <Link
                  to={`${dataLanding.landingInfo.collectionList[2].collectionUrl}`}
                  style={{ display: 'contents' }}
                >
                  <MasonryItemOverlay />

                  <MasonryInfo>
                    <Title sizeMbl="18px" size="24px" color="#fff">
                      {dataLanding.landingInfo.collectionList[2].collectionName}
                    </Title>
                    <Title sizeMbl="12px" size="16px" color="#fff">
                      {
                        dataLanding.landingInfo.collectionList[2]
                          .propsInCollection
                      }
                      {intl.formatMessage({
                        id: 'main-page.collections.offers',
                      })}
                    </Title>
                  </MasonryInfo>
                </Link>
              </MasonryItemThree>
            )}

            {dataLanding.landingInfo.collectionList[3] && (
              <MasonryItemFour
                bg={`https://aktis.villas/media/${dataLanding.landingInfo.collectionList[3].collectionCover}`}
              >
                <Link
                  to={`${dataLanding.landingInfo.collectionList[3].collectionUrl}`}
                  style={{ display: 'contents' }}
                >
                  <MasonryItemOverlay />

                  <MasonryInfo>
                    <Title sizeMbl="18px" size="24px" color="#fff">
                      {dataLanding.landingInfo.collectionList[3].collectionName}
                    </Title>
                    <Title sizeMbl="12px" size="16px" color="#fff">
                      {
                        dataLanding.landingInfo.collectionList[3]
                          .propsInCollection
                      }
                      {intl.formatMessage({
                        id: 'main-page.collections.offers',
                      })}
                    </Title>
                  </MasonryInfo>
                </Link>
              </MasonryItemFour>
            )}

            {dataLanding.landingInfo.collectionList[4] && (
              <MasonryItemFive
                bg={`https://aktis.villas/media/${dataLanding.landingInfo.collectionList[4].collectionCover}`}
              >
                {/* <img
      src={`${process.env.REACT_APP_API_MEDIA_URL}${dataLanding.landingInfo.collectionList[4].collectionCover}`}
      alt=""
      style={{ opacity: '0' }}
    /> */}
                <Link
                  to={`${dataLanding.landingInfo.collectionList[4].collectionUrl}`}
                  style={{ display: 'contents' }}
                >
                  <MasonryItemOverlay />

                  <MasonryInfo>
                    <Title sizeMbl="18px" size="24px" color="#fff">
                      {dataLanding.landingInfo.collectionList[4].collectionName}
                    </Title>
                    <Title sizeMbl="12px" size="16px" color="#fff">
                      {
                        dataLanding.landingInfo.collectionList[4]
                          .propsInCollection
                      }
                      {intl.formatMessage({
                        id: 'main-page.collections.offers',
                      })}
                    </Title>
                  </MasonryInfo>
                </Link>
              </MasonryItemFive>
            )}

            {dataLanding.landingInfo.collectionList[5] && (
              <MasonryItemSix
                bg={`https://aktis.villas/media/${dataLanding.landingInfo.collectionList[5].collectionCover}`}
              >
                <Link
                  to={`${dataLanding.landingInfo.collectionList[5].collectionUrl}`}
                  style={{ display: 'contents' }}
                >
                  <MasonryItemOverlay />

                  <MasonryInfo>
                    <Title sizeMbl="18px" size="24px" color="#fff">
                      {dataLanding.landingInfo.collectionList[5].collectionName}
                    </Title>
                    <Title sizeMbl="12px" size="16px" color="#fff">
                      {
                        dataLanding.landingInfo.collectionList[5]
                          .propsInCollection
                      }
                      {intl.formatMessage({
                        id: 'main-page.collections.offers',
                      })}
                    </Title>
                  </MasonryInfo>
                </Link>
              </MasonryItemSix>
            )}
          </MasonryWrapper>
        )}
    </>
  );
};

export { CollectionMasonryGrid };
